import React from 'react';
import './TopBar.less';
import { Row, Item } from 'react-plan';
import { Link } from 'react-router';
import { Auth } from '../../firebaseInit.js';
import { observer } from 'mobx-react';

type Props = {

}

const strings = {
  title: 'WORLD SPACE SCHOOL',
  profile: 'Profile',
  logout: 'Logout',
  courses: 'My courses'
};

const TopBar = observer(['user'], ({user}) => {
  const avatar = user.profile.avatar || require('../../../img-layout/img-profil.jpg');
  const handleLogout = (e) => {
    e.preventDefault();
    Auth.signOut();
  };

  return (
    <Row
      align="center"
      className="top-bar"
      justify="space-between"
    >
      <Item className="logo" small="100%">
        <Link to="/"><h3 className="logo-typo">{ strings.title }</h3></Link>
      </Item>
      <Row
        align="stretch"
        className="links"
        justify="flex-end"
        small="100%"
      >
        <Link activeClassName="active" to="/profile">
          <span>
            <img className="avatar" src={ avatar } alt={ user.profile.name } />
            { strings.profile }
          </span>
        </Link>
        <Link to="/all">
          <span>
            { strings.courses }
          </span>
        </Link>
        <a href="/" onClick={ handleLogout }><span>{ strings.logout }</span></a>
      </Row>
    </Row>
  );
});

export default TopBar;

//Unit test entry point
export const TopBarTest = TopBar;


/** WEBPACK FOOTER **
 ** ./src/js/app/TopBar/TopBar.jsx
 **/